// ThankYouPage.jsx
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { socket } from "../api";

const Invoice = () => {
  const navigate = useNavigate();
  const [balance, setBalance] = useState(0);

  const userInfo = localStorage.getItem("userInfo")
    ? JSON.parse(localStorage.getItem("userInfo"))
    : null;

  useEffect(() => {
    if (userInfo?.phone) {
      //   console.log("Requesting balance for phone:", userInfo.phone);
      socket.emit("getBalance", { phone: userInfo.phone });

      socket.on("balanceResponse", (data) => {
        //  console.log("Received balance response from server:", data);
        if (data.success) {
          setBalance(data.balance);
        }
      });
    }

    return () => {
      socket.off("balanceResponse");
    };
  }, [userInfo?.phone]);

  return (
    <div className="flex items-center justify-center min-h-screen bg-black text-white px-4">
      <div className="bg-gray-900 p-10 rounded-2xl shadow-lg text-center max-w-md w-full animate-fadeIn">
        <h1 className="text-4xl font-bold mb-4 text-yellow-400">
          🎉 Thank You!
        </h1>
        <p className="text-gray-300 mb-6 text-lg">
          {userInfo?.username ? `${userInfo?.username}, ` : ""}
          Your balance is{" "}
          <span className="font-semibold text-white">{balance} ETB</span>
          <br />
        </p>
        <button
          onClick={() => navigate("/betamountpage")}
          className="bg-yellow-400 text-black font-bold py-2 px-6 rounded-lg hover:bg-yellow-500 transition transform hover:scale-105"
        >
          Play Now
        </button>
      </div>
    </div>
  );
};

export default Invoice;
